import React from 'react'
import { useTranslation } from 'next-i18next'
import { FormikProps } from 'formik'

import { Listing } from '../../types/Listing'
import CustomRadioButton from '../custom-radio-button'

type Props = {
  formikProps: FormikProps<Listing>
}

const PropertySpace = ({ formikProps }: Props) => {
  const { t } = useTranslation()
  const { values } = formikProps
  const options = {
    condo: [
      {
        key: t('b.listing.view.entire_apartment.text', 'Entire Apartment'),
        value: 'entire'
      },
      {
        key: t('b.listing.view.partial_apartment.text', 'Partial apartment'),
        value: 'partial'
      },
      {
        key: t('common.room', 'Room'),
        value: 'single'
      }
    ],
    house: [
      {
        key: t('b.listing.view.entire_house.text', 'Entire House'),
        value: 'entire'
      },
      {
        key: t('b.listing.view.partial_house.text', 'Partial House'),
        value: 'partial'
      },
      {
        key: t('common.room', 'Room'),
        value: 'single'
      }
    ],
    townhouse: [
      {
        key: t('b.listing.view.entire_townhouse.text', 'Entire Townhouse'),
        value: 'entire'
      },
      {
        key: t('b.listing.view.partial_townhouse.text', 'Partial Townhouse'),
        value: 'partial'
      },
      {
        key: t('common.room', 'Room'),
        value: 'single'
      }
    ]
  }

  return (
    <CustomRadioButton
      options={options[values.type as keyof typeof options]}
      name="scope"
      control="radio"
    />
  )
}

export default PropertySpace
